/**
 * @zh_CN GITHUB 仓库地址
 */
export const VBEN_GITHUB_URL = 'https://github.com/vbenjs/vue-vben-admin';

/**
 * @zh_CN 文档地址
 */
export const VBEN_DOC_URL = 'https://doc.vben.pro';

/**
 * @zh_CN Vben Logo
 */
export const VBEN_LOGO_URL =
  'https://unpkg.com/@vbenjs/static-source@0.1.7/source/logo-v1.webp';

/**
 * @zh_CN Vben Admin 首页地址
 */
export const VBEN_PREVIEW_URL = 'https://www.vben.pro';

export const VBEN_ELE_PREVIEW_URL = 'https://ele.vben.pro';

export const VBEN_NAIVE_PREVIEW_URL = 'https://naive.vben.pro';

export const VBEN_ANT_PREVIEW_URL = 'https://ant.vben.pro';
